import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Typography, Spin, DatePicker, Alert } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useVipClub from '../useVipClub';
import LineChart from '../../../charts/lineChart';
import BarChangeChart from '../../../charts/barChange';
import AlertMessage from '../../../components/alertMessage';
import moment from 'moment';
import Helpers from '../../../../../helpers';
import { ResponsivePie } from '@nivo/pie';
import PieChart from '../pieChart';
import { useMemo } from 'react';
import UIHelper from '../../../../../helpers/UIHelper';

const sexData = [
  {
    id: 'stylus',
    label: 'stylus',
    value: 82,
    color: 'hsl(200, 70%, 50%)',
  },
  {
    id: 'c',
    label: 'c',
    value: 41,
    color: 'hsl(56, 70%, 50%)',
  },
  {
    id: 'sass',
    label: 'sass',
    value: 355,
    color: 'hsl(12, 70%, 50%)',
  },
  {
    id: 'elixir',
    label: 'elixir',
    value: 35,
    color: 'hsl(77, 70%, 50%)',
  },
  {
    id: 'python',
    label: 'python',
    value: 200,
    color: 'hsl(46, 70%, 50%)',
  },
];

const MainPage = () => {
  const {
    //
    columsForProfileType,
    allData,
    mergeArrays,
    columsForTopCountry,
    columsForCity,
    columsForStatus,
    columsForConventionType,
    columsForPoints,
    columsForMoreFiveThousand,
    columsForCompanyAmount,
    columsForRegistration,
    filters,
    format,
    loading,
    searchParams,
    //
    data,
    handleDownloadExcel,
    handleDownloadPdf,
    loadingPdf,
  } = useVipClub();

  const { t } = useTranslation();

  const fromToText = useMemo(() => {
    const objSP = Object.fromEntries([...searchParams]);

    const to = objSP.date_to;

    return `al ${moment(to, 'DD-MM-YYYY').format('DD MMMM YYYY')}`;
  }, [searchParams]);

  const mergedStatusAndUnsubscribes = mergeArrays(allData?.status, allData?.user_unsubscribe, allData?.user_without_unsubscribe);
  const mergedStatusAndUnsubscribesAll = mergeArrays(allData?.status_all, allData?.user_unsubscribe_all, allData?.user_without_unsubscribe_all);

  return (
    <>
      <PageHeader title={t('CRM').toUpperCase()}>
        <Row gutter={16}>
          {/*<Col>*/}
          {/*  <Button*/}
          {/*    big*/}
          {/*    type={'green'}*/}
          {/*    iconMargin*/}
          {/*    width={'138px'}*/}
          {/*    icon={<ExcelIcon fill={'#fff'} />}*/}
          {/*    onClick={handleDownloadExcel}*/}
          {/*    loading={loading}*/}
          {/*  >*/}
          {/*    {t('Export')}*/}
          {/*  </Button>*/}
          {/*</Col>*/}
          <Col>
            <Button
              big
              icon={<PlusOutlined />}
              loading={loadingPdf}
              onClick={() => handleDownloadPdf('CRM')}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} allFilters />
        {!searchParams.get('date_from') && (
          <>
            <br />
            <Alert
              message={t('Periodo non può essere lasciato in bianco')}
              type='error'
            />
          </>
        )}
        {!searchParams.get('by_shopping_center') && (
          <>
            <br />
            <Alert
              message={t('Outlet Village non può essere lasciato in bianco')}
              type='error'
            />
          </>
        )}
        {searchParams.get('date_from') && (
          <Spin spinning={loading}>
            <br />
            <Row gutter={[20, 20]}>
              <Col span={24}>
                <Typography.Title level={3}>{t('Brands over 5000 punti')} </Typography.Title>
                <Table
                  columns={columsForMoreFiveThousand}
                  dataSource={allData.moreFiveThousand}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                />
              </Col>
              <Col span={24}>
                <Typography.Title level={3}>
                  {t('Distribuzione per tipologia punti')}
                </Typography.Title>
                <BarChangeChart
                  keys={['Age']}
                  data={allData.transactionTypeAll}
                  formatTooltip={Helpers.changeDotToComa}
                  lineItemWidth={180}
                  itemWidth={160}
                  // format={format}
                  translateX={200}
                  hideLine
                  layout={'horizontal'}
                  margin={{ top: 50, right: 0, bottom: 100, left: 230 }}
                  hideLegend
                  hideTooltipKey={true}
                />
              </Col>
              <Col span={24}>
                <Typography.Title level={3}>
                  {t('Distribuzione punti infopoint')}
                </Typography.Title>
                <BarChangeChart
                  keys={['Age']}
                  data={allData.transactionInfo}
                  formatTooltip={Helpers.changeDotToComa}
                  lineItemWidth={180}
                  itemWidth={160}
                  // format={format}
                  translateX={200}
                  hideLine
                  layout={'horizontal'}
                  margin={{ top: 50, right: 0, bottom: 100, left: 230 }}
                  hideLegend
                  hideTooltipKey={true}
                />
              </Col>
              {/*<Col span={24}>*/}
              {/*  <Typography.Title level={3}>*/}
              {/*    {t('Distribuzione clienti per soglie')} {fromToText}*/}
              {/*  </Typography.Title>*/}
              {/*  <Table*/}
              {/*    columns={columsForPoints}*/}
              {/*    dataSource={allData.points}*/}
              {/*    pagination={{*/}
              {/*      pageSize: 10000,*/}
              {/*      position: ['bottomCenter'],*/}
              {/*      hideOnSinglePage: true,*/}
              {/*      showSizeChanger: false,*/}
              {/*    }}*/}
              {/*    bordered*/}
              {/*    scroll={{ x: 700 }}*/}
              {/*  />*/}
              {/*</Col>*/}
              <Col span={24}>
                <Typography.Title level={3}>
                  {t('Convenzioni aziendali')}
                </Typography.Title>
                <Table
                  columns={columsForConventionType}
                  dataSource={allData.conventionType}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                />
              </Col>
              <Col span={24}>
                <Typography.Title level={3}>
                  {t('Utenti totali')}: {allData.total_users}
                </Typography.Title>
              </Col>
              <Col span={24}>
                <Typography.Title level={3}>
                  {t('Distribuzione soglie')}
                </Typography.Title>
                <Table
                  columns={columsForStatus}
                  dataSource={mergedStatusAndUnsubscribes}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                />
              </Col>
              <Col span={24}>
                <Typography.Title level={3}>
                  {`${t('Distribuzione soglie')} ${fromToText}`}
                </Typography.Title>
                <Table
                  columns={columsForStatus}
                  dataSource={mergedStatusAndUnsubscribesAll}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                />
              </Col>
              <Col span={24}>
                <Typography.Title level={3}>
                  {t('Top 10 Provincia')}
                </Typography.Title>
                <Table
                  columns={columsForCity}
                  dataSource={allData.city}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                />
              </Col>
              <Col span={24}>
                <Typography.Title level={3}>{t('Gender')}</Typography.Title>
                <Typography.Title level={3}>{t('Totale registrati')}: {allData.total_users}</Typography.Title>
                <div className={styles.pieChart}>
                  <PieChart data={allData.sex} />
                </div>
              </Col>
              <Col span={24}>
                <Typography.Title level={3}>
                  {t('TOP 10 Nazionalità')}
                </Typography.Title>
                <Table
                  columns={columsForTopCountry}
                  dataSource={allData.country}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                />
              </Col>
              <Col span={24}>
                <Typography.Title level={3}>{t('Fasce deta')}</Typography.Title>
                <Col span={24}>
                  <BarChangeChart
                    keys={['Age']}
                    data={allData.barChartAge}
                    formatTooltip={Helpers.changeDotToComa}
                    lineItemWidth={180}
                    itemWidth={160}
                    format={format}
                    translateX={200}
                    hideLine
                  />
                </Col>
                <Typography.Title level={3}>
                  {t('Profilo extra')}
                </Typography.Title>

                <Table
                  columns={columsForProfileType}
                  dataSource={allData.profile_type}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                />
              </Col>

              <Col span={24}>
                <Typography.Title level={3}>{t('Tenant')}</Typography.Title>
                <Typography.Title level={3}>
                  {t('Saldo Punti')}: {allData.total_amount}
                </Typography.Title>
                <Table
                  columns={columsForCompanyAmount}
                  dataSource={allData.companyAmount}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                />
              </Col>

              <Col span={24}>
                <Typography.Title level={3}> {`${t('Registrati')} ${fromToText}`}</Typography.Title>
                <Typography.Title level={3}>
                </Typography.Title>
                <Table
                  columns={columsForRegistration}
                  dataSource={allData.touchPointAll}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                />
              </Col>

              <Col span={24}>
                <Typography.Title level={3}>{t('Registrati')}</Typography.Title>

                <Typography.Title level={3}>
                </Typography.Title>
                <Table
                  columns={columsForRegistration}
                  dataSource={allData.touchPoint}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 700 }}
                />
              </Col>

            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default MainPage;
